import { cloneDeep } from 'lodash';
import { DOWNLOAD_FORM } from '../../../redux/queryResults/models/queryResults.types';
import { CHECKBOX_GROUP_TYPES, ICheckBox, isCHECKBOX_GROUP_TYPES } from '../../NQTCheckBox/NQTCheckBox.models';
import { DownloadEnums } from './DownloadPanel.interfaces';

export const updateSelected = (
  type: CHECKBOX_GROUP_TYPES,
  setIsValid: React.Dispatch<React.SetStateAction<boolean>>,
  tabArr: ICheckBox[],
  testArr: ICheckBox[]
): void => {
  if (isCHECKBOX_GROUP_TYPES(type)) {
    switch (type) {
    case 'DOWNLOAD_TAB':
      (
        !!tabArr.filter(tab => tab.isSelected).length ||
        !!testArr.filter(test => test.isSelected).length
      ) ?
        setIsValid(true) :
        setIsValid(false);
      break;
    case 'DOWNLOAD_TEST':
      (
        !!tabArr.filter(tab => tab.isSelected).length ||
        !!testArr.filter(test => test.isSelected).length
      ) ?
        setIsValid(true) :
        setIsValid(false);
      break;
    case 'EXCEL_OPTION':
      setIsValid(true);
      break;
    default:
      break;
    }
  }
};

export const resetSelections = (
  prevTabsForDownload: DownloadEnums[],
  prevTestsForDownload: DownloadEnums[],
  prevSelectedFormat: DOWNLOAD_FORM,
  prevExcelOptsForDownload: DownloadEnums[],
  setTabsForDownload: React.Dispatch<React.SetStateAction<DownloadEnums[]>>,
  setTestsForDownload: React.Dispatch<React.SetStateAction<DownloadEnums[]>>,
  setSelectedFormat: React.Dispatch<React.SetStateAction<DOWNLOAD_FORM>>,
  setExcelOptsForDownload: React.Dispatch<React.SetStateAction<DownloadEnums[]>>,
  setHideCheckboxes: React.Dispatch<React.SetStateAction<boolean>>
):void => {
  setTabsForDownload(cloneDeep(prevTabsForDownload));
  setTestsForDownload(cloneDeep(prevTestsForDownload));
  setSelectedFormat(cloneDeep(prevSelectedFormat));
  setExcelOptsForDownload(cloneDeep(prevExcelOptsForDownload));
  (DOWNLOAD_FORM.EXCEL === prevSelectedFormat) ?
    setHideCheckboxes(true) :
    setHideCheckboxes(false);
};


export const tabToShareTopFromDownload = (goToTop: boolean) => (e: React.KeyboardEvent): void => {
  if (!goToTop) { return; }
  if (e.key === 'Tab' && !e.shiftKey) {
    const shareLinkButton = document.getElementById('nqt-shl--show-button') as HTMLElement;
    if (shareLinkButton.hasAttribute('disabled')) {
      //e.preventDefault();
    } else {
      e.preventDefault();
      shareLinkButton.focus();
    }
  }
};
  
